export default __webpack_public_path__ + "static/media/runas.2baf5f24.png";